import type { FallbackProps } from 'react-error-boundary';
import { Button } from '@shared/components/ui/Button';
import {
  Card,
  CardHeader,
  CardTitle,
  CardDescription,
  CardContent,
  CardFooter,
} from '@shared/components/ui/Card';

export function ErrorFallback({ error, resetErrorBoundary }: FallbackProps) {
  const isDev = import.meta.env.DEV;

  const handleRefresh = () => {
    window.location.reload();
  };

  const handleGoBack = () => {
    window.history.back();
  };

  return (
    <div className="flex min-h-[400px] items-center justify-center p-4">
      <Card className="w-full max-w-md">
        <CardHeader className="text-center">
          <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-red-100 dark:bg-red-900/20">
            <span className="text-3xl" aria-hidden="true">
              ⚠️
            </span>
          </div>
          <CardTitle className="text-xl text-red-700 dark:text-red-400">
            Algo salió mal
          </CardTitle>
          <CardDescription>
            Ha ocurrido un error inesperado. Por favor, intente de nuevo.
          </CardDescription>
        </CardHeader>

        {isDev && error?.message && (
          <CardContent>
            <details className="rounded-md bg-gray-100 p-3 text-sm dark:bg-gray-800">
              <summary className="cursor-pointer font-medium text-gray-700 dark:text-gray-300">
                Detalles del error (desarrollo)
              </summary>
              <pre className="mt-2 overflow-auto whitespace-pre-wrap text-xs text-red-600 dark:text-red-400">
                {error.message}
              </pre>
            </details>
          </CardContent>
        )}

        <CardFooter className="flex justify-center gap-3">
          <Button variant="outline" onClick={handleGoBack}>
            Volver
          </Button>
          <Button variant="outline" onClick={handleRefresh}>
            Recargar página
          </Button>
          <Button onClick={resetErrorBoundary}>Intentar de nuevo</Button>
        </CardFooter>
      </Card>
    </div>
  );
}
